module.exports = __webpack_public_path__ + "img/nossa-historia.3722b887.webp";